// removed by extract-text-webpack-plugin
module.exports = {"ButtonDetail":"ButtonDetail"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/LoadDetail/LoanContract/ButtonDetail/style.scss
// module id = 2254
// module chunks = 10